export const fetchSearchResults = (query, page, pageSize)=>async ()=>{
        let headers = new Headers();
        headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
        const response = await fetch(`/api/v1/search?query=${query}&page=${page}&pageSize=${pageSize}`, {
            headers
        });
        if (response.ok) {
            const body = await response.json();
            return {
                kind: "result",
                value: {
                    totalResults: body.Count,
                    results: body.Results,
                    query,
                    page
                },
                status: response.status
            };
        }
        return {
            kind: "failed",
            status: response.status
        };
    };
